var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-label",style:({
		backgroundColor: _vm.color
	}),attrs:{"title":_vm.title}},[_vm._v(" Level "+_vm._s(_vm.level)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }